import { render, staticRenderFns } from "./modify-client.vue?vue&type=template&id=5a29aab2&scoped=true"
import script from "./modify-client.vue?vue&type=script&lang=ts"
export * from "./modify-client.vue?vue&type=script&lang=ts"
import style0 from "./modify-client.vue?vue&type=style&index=0&id=5a29aab2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a29aab2",
  null
  
)

export default component.exports